<p-floatlabel variant="in" class="input-field">
  <p-iconfield>
    @if (this.prefixIcon && this.prefixIcon !== '') {
      @if (this.prefixIcon === 'en') {
        <p-inputicon>
          <img src="assets/icon/english-flag.svg" alt="" width="16" height="16" />
        </p-inputicon>
      } @else if (this.prefixIcon === 'nb') {
        <p-inputicon>
          <img src="assets/icon/norwegian-flag.svg" alt="" width="16" height="16" />
        </p-inputicon>
      } @else {
        <p-inputicon [styleClass]="'pi ' + this.prefixIcon" />
      }
    }
    <input
      pInputText
      id="input_field"
      [type]="type"
      [formControl]="control"
      autocomplete="off"
      [fluid]="true"
      [class.ng-invalid]="control.invalid && control.touched"
      [class.ng-dirty]="control.touched"
    />
  </p-iconfield>
  <label for="input_field">{{ label }}</label>
</p-floatlabel>
<small class="input-field-error" [class.input-field-error--hidden]="!(control.invalid && control.touched)">{{
  errorMessage ?? 'This field is required'
}}</small>
